import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { RedirectIfAuthenticatedGuard } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { LessonComponent } from './lesson.component';
import { LessonNoAuthComponent } from './lesson-no-auth.component';
import { LessonDetailComponent } from './lesson-detail.component';
import { LessonPopupComponent } from './lesson-dialog.component';
import { LessonDeletePopupComponent } from './lesson-delete-dialog.component';
import { LessonConfirmCancelPopupComponent } from './lesson-confirm-cancel-dialog.component';
import { LessonSendNotificationPopupComponent } from './lesson-send-notification-dialog.component';
import { LessonConfirmExecutedPopupComponent } from './lesson-confirm-executed-dialog.component';

import { Principal } from '../../shared';
import { LessonBulkCreatePopupComponent } from './lesson-bulk-create-dialog.component';
import { LessonChoosePaymentMethodPopupComponent } from './lesson-choose-payment-method-dialog.component';

@Injectable()
export class LessonResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'begining,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const lessonRoute: Routes = [
    {
        path: 'lesson',
        component: LessonComponent,
        resolve: {
            'pagingParams': LessonResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.lesson.home.title'
        }
    }, {
        path: 'lesson-public',
        component: LessonNoAuthComponent,
        canActivate: [RedirectIfAuthenticatedGuard],
        resolve: {
            'pagingParams': LessonResolvePagingParams
        },
        data: {
            pageTitle: 'jYoguiApp.lesson-public.home.title'
        }
    }, {
        path: 'lesson-public/school/:schoolId',
        component: LessonNoAuthComponent,
        canActivate: [RedirectIfAuthenticatedGuard],
        resolve: {
            'pagingParams': LessonResolvePagingParams
        },
        data: {
            pageTitle: 'jYoguiApp.lesson-public.home.title'
        }
    }, {
        path: 'lesson/:id',
        component: LessonDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.lesson.home.title'
        }
    }
];

export const lessonPopupRoute: Routes = [
    {
        path: 'lesson-new',
        component: LessonPopupComponent,
        data: {
            authorities: ['ROLE_USER', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.lesson.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'lesson-bulk-new',
        component: LessonBulkCreatePopupComponent,
        data: {
            authorities: ['ROLE_USER', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.lesson.home.bulkCreateTitle'
        },
        outlet: 'popup'
    },
    {
        path: 'lesson/:id/edit',
        component: LessonPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.lesson.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'lesson/:id/delete',
        component: LessonDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.lesson.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'lesson/:id/cancel',
        component: LessonConfirmCancelPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ],
            pageTitle: 'jYoguiApp.lesson.cancel.title'
        },
        outlet: 'popup'
    },
    {
        path: 'lesson/:id/executed',
        component: LessonConfirmExecutedPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ],
            pageTitle: 'jYoguiApp.lesson.executed.title'
        },
        outlet: 'popup'
    },
    {
        path: 'lesson/:id/send-notification',
        component: LessonSendNotificationPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ],
            pageTitle: 'jYoguiApp.lesson.sendNotification.title'
        },
        outlet: 'popup'
    },
    {
        path: 'lesson/:id/choose-payment-method',
        component: LessonChoosePaymentMethodPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.lesson.home.title'
        },
        outlet: 'popup'
    },
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson.route.ts